export default "__VITE_ASSET__C78zKu9w__"